import { useHolidayStore } from '@/store/useHolidayStore';

export function RewardOverlay() {
  const { tweetVerified } = useHolidayStore();

  if (!tweetVerified) return null;

  return (
    <div className="fixed inset-0 z-[150] flex items-center justify-center pointer-events-none">
      <img
        src="/burnpast.png"
        alt="Burn Past Reward"
        className="max-w-full max-h-full object-contain animate-holiday-reward-reveal"
      />
    </div>
  );
}
